<template>
  <div class="container text-center">
    <div class="row align-items-center">
      <div class="col">
        <!-- Articles Section -->
      <div class="space-1 space-top-xl-1 space-bottom-lg-1">
        <!-- Title -->
        <div
          class="container w-md-80 w-lg-50 text-center mx-md-auto mb-5 mb-md-5"
        >
        <img
          src="@/assets/logo.png"
          fluid
          alt="Parceiro CAIXA"
          width="100"
          height="100"
        />
        <br>
          <span
            class="badge badge-pill badge-soft-success mt-5 p-3 small font-weight-bold mb-3"
            >E-mail validado com sucesso!</span
          >
          <h2 class="font-weight-light my-2">
            Agora é só aguardar o contato de boas vindas do seu consultor para liberar o seu acesso ao sistema!
          </h2>
            <footer class="blockquote-footer mb-3">
                Caso já tenha feito contato acesso o portal pelo botão abaixo.
            </footer>

            <router-link to="/login">
              <button
              class="btn btn-info mt-4"
              to="/login"
            >
              Acessar o sistema
            </button>
          </router-link>
        </div>
        <!-- End Title -->
      </div>
      <!-- End Articles Section -->
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  name: "login",
  data() {
    return {
      email: "",
      pass: "",
    };
  },
  methods: {
    ...mapActions(["loginUser", "recoveryPass", "dismissed","handleVerifyEmail"]),
  },
  computed: {
    ...mapState(["error", "errorMessage", "dismissCountDown"]),
  },
  mounted() {
    this.handleVerifyEmail({
      email: this.$route.params.email,
      actionCode: this.$route.query.oobCode
    })
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.bv .row {
  min-height: 100vh;
}
.form-signin {
  width: 100%;
  max-width: 330px;
  padding: 15px;
  margin: 0 auto;
}
</style>
